<template>
  <div class="const">
    <div class="sear">
      <label>从</label>
      <el-date-picker v-model="startDate" type="date" placeholder="选择日期" style="width:150px"></el-date-picker>
      <label>到</label>
      <el-date-picker v-model="endDate" type="date" placeholder="选择日期" style="width:150px"></el-date-picker>
      <el-button type="primary" style="margin-left:20px;" v-on:click="tionSears()">确定</el-button>
    </div>
    <div style="padding:0 20px;margin-top:17px;">
      <el-table
        :data="tableData"
        border
        style="width: 99%;overflow:auto"
        height="calc(100vh - 400px)"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <el-table-column prop="r_data" label="开机时间"></el-table-column>
        <el-table-column prop="r_title" label="关机时间"></el-table-column>
        <el-table-column prop="r_username" label="用户名"></el-table-column>
      </el-table>
    </div>
    <div class="p_btns">
      <el-pagination
        small
        layout="prev, pager, next"
        :page-size="pagesize"
        :total="total"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { http } from "./../../https";
export default {
  data() {
    return {
      startDate: "",
      endDate: "",
      tableData: [],
      page: 0,
      pagesize: 8,
      total: 0,
      loading: false
    };
  },
  created() {
    let timeStamp = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;
    let SevenDayAgo = timeStamp - 86400 * 7;
    let start_time = SevenDayAgo;
    this.startDate = this.timestampToTime(start_time);
    let end_time =
      new Date(new Date().setHours(23, 59, 59, 0)).getTime() / 1000;
    this.endDate = this.timestampToTime(end_time);
    this.tionSear();
  },
  methods: {
    tionSears() {
      this.page = 0;
      this.tionSear();
    },
    tionSear() {
      const user_name = sessionStorage.getItem("user_name");
      const mac = sessionStorage.getItem("mac");
      const oauth_token = sessionStorage.getItem("oauth_token");
      const type = 15;
      const subtype = 1;
      this.loading = true;
      let macSplit = mac.replace(/-/g, "");
      let start_time = new Date(this.startDate).getTime() / 1000;
      let end_time = new Date(this.endDate).getTime() / 1000;
      const page = this.page;
      const pageSize = this.pagesize;
      let url = `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=getLogRecord&mac=${mac}&oauth_token=${oauth_token}&type=${type}&subtype=${subtype}&page=${page}&page_count=${pageSize}&start_time=${start_time}&end_time=${end_time}`;
      http({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          this.loading = false;
          for (let s of res.data.table) {
            s.time = this.timestampToTime(s.r_time);
          }
          this.tableData = res.data.table;
          this.total = res.data.total;
        })
        .catch(res => {
          this.loading = false;
          console.log(res);
        });
    },
    handleCurrentChange(e) {
      this.page = e - 1;
      this.tionSear();
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      return Y + M + D + h + m;
    }
  }
};
</script>
<style scoped>
.const {
  background: #ffffff;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  text-align: left;
  overflow: auto;
}
.const .sear {
  margin-left: 26px;
  font-size: 15px;
  font-weight: 400;
  color: rgba(141, 141, 141, 1);
  padding-top: 20px;
  text-align: right;
  padding-right: 20px;
}
.const .sear label {
  margin: 0 15px;
}
.const /deep/.el-table thead tr th {
  text-align: center;
  background: #e3e3e3;
  font-size: 18px;
  font-weight: 400;
  color: rgba(92, 91, 91, 1);
}
.const /deep/.el-table tbody tr td {
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: rgba(164, 164, 164, 1);
}
.const /deep/.el-table tbody tr td a {
  text-decoration: none;
  font-size: 13px;
  font-weight: 400;
  color: rgba(114, 166, 254, 1);
}
.const .p_btns {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}
.const .p_btns .hybb {
  margin-left: 20px;
  padding: 8px 44px;
  border: 1px solid rgba(40, 120, 255, 1);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 400;
  color: #2878ff;
  margin-right: 25px;
  cursor: pointer;
}
.const .p_btns .hybb:hover {
  background: #2878ff;
  color: #fff;
}
</style>